export default "__VITE_ASSET__888e9011__"